export default __webpack_public_path__ + "static/media/DinosaursSeaReptiles_11.651f38c3.png";